/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_REWARDS_POINTS_ELIGIBILITY = 'MFE/CHECKOUT/LOAD/REWARDS_POINTS_ELIGIBILITY';
export const SET_REWARDS_POINTS_ELIGIBILITY = 'MFE/CHECKOUT/SET/REWARDS_POINTS_ELIGIBILITY';
export const LOAD_REWARDS_POINTS = 'MFE/CHECKOUT/LOAD/LOAD_REWARDS_POINTS';
export const SET_LOAD_REWARDS_POINTS = 'MFE/CHECKOUT/SET/LOAD_REWARDS_POINTS';
export const SET_SELECTED_REWARDS_POINTS = 'MFE/CHECKOUT/SET/SELECTED_REWARDS_POINTS';
export const CLEAR_ALL_REWARDS_POINTS = 'MFE/CHECKOUT/CLEAR_ALL_REWARDS_POINTS';
export const CLEAR_SELECTED_REWARDS_POINTS = 'MFE/CHECKOUT/CLEAR_SELECTED_REWARDS_POINTS';
